import { wordService } from "../services/wordService";

export const applyTable = () => wordService.applySemanticTag({ type: "table", requireTableSelection: true });
export const applyTableCaption = async () =>
  wordService.applySemanticTag({ type: "table_caption", metadata: { parent: await wordService.latestSemanticId("table") } });
export const applyTableNotes = async () =>
  wordService.applySemanticTag({ type: "table_note", metadata: { parent: await wordService.latestSemanticId("table") } });
